import { render, staticRenderFns } from "./PageTemplates.vue?vue&type=template&id=6433cd02"
import script from "./PageTemplates.vue?vue&type=script&lang=js"
export * from "./PageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports